import { useCallback, useEffect, useState } from 'react';
import { apiUrl, authFetch } from '../config/apiClient';
import { clearLegacyToken, clearSessionToken } from '../config/auth';
import { clearOfflineData } from '../offlineDataCache';

export function useAuth() {
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      clearLegacyToken();
      try {
        const response = await authFetch(apiUrl('/api/auth/me'));
        if (response.ok) {
          const userData = await response.json();
          setUser(userData);
        } else {
          clearSessionToken();
        }
      } catch (err) {
        console.error('Auth check failed:', err);
      } finally {
        setAuthLoading(false);
      }
    };
    checkAuth();
  }, []);

  const handleLoginSuccess = useCallback((loggedInUser) => {
    setUser(loggedInUser);
  }, []);

  const clearSession = useCallback(() => {
    clearSessionToken();
    setUser(null);
  }, []);

  const logout = useCallback(async ({ beforeUserClear } = {}) => {
    try {
      await authFetch(apiUrl('/api/auth/logout'), { method: 'POST' });
    } catch (err) {
      console.error('Logout error:', err);
    }
    clearSessionToken();
    await clearOfflineData(user);
    if (beforeUserClear) {
      beforeUserClear();
    }
    setUser(null);
  }, [user]);

  return {
    user,
    authLoading,
    handleLoginSuccess,
    clearSession,
    logout,
  };
}
